/* eslint-disable max-len */
import React, { useState,useEffect} from 'react'
import { useContext } from 'react'
import TopHeader from '../../components/TopHeader'
import { motion } from 'framer-motion'
import { useDropzone } from 'react-dropzone';
import GlobalContext from '../../components/Context/GloablContext';
import Loader from '../../components/Loader';
import S3UploadHookImport from '../../CommonMethods/s3UploadHookImport';
import ImportHistoryTable from './Components/ImportHistoryTable';
import {useGetImportSampleFileQuery,useImportPatientMutation,useImportOrgUserMutation, useLazyGetImportListQuery} from '../../slices/importSlice'
import HelpGuideModal from '../../components/HelpGuideModal';
import {useGetHelpGuideOrganizationQuery} from '../../slices/patientSlice'


export default function ManageImport() {
    const [patientTabName, setPatientTabName] = useState('patient');
    const [patientErrorMessage, setPatientErrorMessage] = useState('');
    const [organizationErrorMessage, setOrganizationErrorMessage] = useState('');
    const [patientErrorFileName, setPatientErrorFileName] = useState('');
    const [organizationErrorFileName, setOrganizationErrorFileName] = useState('');
    const { setToastmessage,setToastErrorMessage } = useContext(GlobalContext);
    const { refetch, } = useGetImportSampleFileQuery(`type=${patientTabName}`);
    const [downloadfileLoading,setDownloadfileLoading]=useState(false)
    const [importPatient] = useImportPatientMutation()
    const [importOrgUser] = useImportOrgUserMutation()
    const [fileImportLoading ,setFileImportLoading]=useState(false)
    const userType = sessionStorage.getItem('user_type')
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const [loading, setLoading]=useState(false);
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    const [trigger, { data, error, isLoading, isFetching,status }] = useLazyGetImportListQuery();

 
    // handle tab change
    const handleTabChange = (tabName) => {
        setPatientTabName(tabName);
        handleGoBack();
        trigger(`type=${tabName}`);
    };

    const onDropPatient = (acceptedFiles) => {
        const file =acceptedFiles[0];
        handleFileUpload(file, setPatientErrorMessage, setPatientErrorFileName);
    };
     
    const onDropOrganization = (acceptedFiles) => {
        const file = acceptedFiles[0];
        handleFileUpload(file, setOrganizationErrorMessage, setOrganizationErrorFileName);
    };

    // handle file upload
    const handleFileUpload = async (file, e) => {
        setLoading(true)
        const maxSize = 1 * 1024 * 1024 * 1024; // 1GB in bytes
        const userId = userType === 'super-admin' ? 'SUPERADMIN' : sessionStorage.getItem('user_id');
        if (!file) return;
        const fileNameWithType = `${file.name}`;
        const fileName = file.name.split('.').slice(0, -1).join('.');
        const key = `${fileName}-${userId}.csv`;
        if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
            if(patientTabName==='patient'){
                setPatientErrorFileName(fileNameWithType);
                setPatientErrorMessage('File type error: Upload a CSV');
            }
            else {
                setOrganizationErrorFileName(fileNameWithType);
                setOrganizationErrorMessage('File type error: Upload a CSV');
            }
            
            return;
        } else if (file.size > maxSize) {
            if(patientTabName==='patient'){
                setPatientErrorFileName(fileNameWithType);
                setPatientErrorMessage(' File size exceeds the allowed limit. Max: 1,000 mb');
            }
            else{
                setOrganizationErrorFileName(fileNameWithType);
                setOrganizationErrorMessage(' File size exceeds the allowed limit. Max: 1, 000 mb');
            }
            return;
        }
        setFileImportLoading(true);
        try {
            // Upload file to S3
            const s3Url = await S3UploadHookImport(file, key); 
            let response;
            // Call importPatient mutation with the S3 URL
            if(patientTabName==='patient'){
                response = await importPatient({ key: `imports/${key}` }); // Assuming 'key' field in importPatient mutation expects the file name
                setTimeout(() => {
                    trigger(`type=${patientTabName}`);
                }, 4000);
                
            }
            else{
                response = await importOrgUser({ key: `imports/${key}` }); // Assuming 'key' field in import Organization User mutation expects the file name
                setTimeout(() => {
                    trigger(`type=${patientTabName}`);
                }, 4000);            }
            
            
            // Check for success or failure
            if (response.data && response.data.message) {
                setToastmessage(response.data.message); // Show the message from API response
            } else {
                if(patientTabName==='patient'){
                    setPatientErrorFileName(fileNameWithType);
                    setPatientErrorMessage(response.error.data.message)
                }
                else {
                    setOrganizationErrorFileName(fileNameWithType);
                    setOrganizationErrorMessage(response.error.data.message)
                }

            }
        } catch (error) {
            console.log(error)
        } finally {
            setFileImportLoading(false);
        }
        setLoading(false)

    };
    

    // for drag and drop
    const { getRootProps: getPatientRootProps, getInputProps: getPatientInputProps } = useDropzone({
        onDrop: onDropPatient,
        accept: '.csv'
    });

    const { getRootProps: getOrganizationRootProps, getInputProps: getOrganizationInputProps } = useDropzone({
        onDrop: onDropOrganization,
        accept: '.csv'
    });


    // handle goback function
    const handleGoBack = () => {
        setPatientErrorFileName('');
        setOrganizationErrorFileName('');
        setPatientErrorMessage('');
        setOrganizationErrorMessage('');
        setLoading(false);
    };


    // for truncatefile
    const truncateFilename = (filename, maxLength) => {
        if (filename.length <= maxLength) {
            return filename;
        }
        const separator = '...';
        const sepLen = separator.length;
        const charsToShow = maxLength - sepLen;
        const frontChars = Math.ceil(charsToShow / 2);
        const backChars = Math.floor(charsToShow / 2);
        return filename.substr(0, frontChars) + separator + filename.substr(filename.length - backChars);
    };

    // handle download sample file
    const handleDownloadFile = async () => {
        try {
            setDownloadfileLoading(true); 
            const result = await refetch(); // Trigger the API call
            if (result.data) {
                const url = result.data; // Assuming `data` is the URL retrieved from the query
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank'; // Open in a new tab, if desired
                a.click();
                a.remove();
                setDownloadfileLoading(false); 
                setToastmessage('Sample File Downloaded Successfully');
            } else {
                console.error('No download URL available.'); // Handle error or provide feedback
            }
        } catch (error) {
            console.error('Download failed:', error);
        }
    };


    useEffect(() => {
        trigger(`type=${patientTabName}`);
    }, [])

    useEffect(() => {
        if (data?.status === 'In Progress') {

            setTimeout(() => {
                trigger(`type=${patientTabName}`);
            }, 8000);

        }
    }, [data]);

    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-import');
        } else {
            setQueryParamsorg('type=org-user-import');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);


    
    return (
        <div className={` pt-[95px] px-[30px] bg-[#F9F3F5] h-full w-full overflow-x-hidden`}>
            <TopHeader title={"Import"} />
            <>
                <div className={`rounded-lg ${patientErrorMessage ? 'xl:h-customh3 h-customh13':'h-customh3'} bg-white `}>
                    <motion.div
                        className="mt-1"
                        animate={{ x: 0 }}
                        initial={{ x: -10 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div>
                            <div className='mx-7'>
                                
                                <div className='flex justify-between items-end h-12'>
                                    <div className='flex pb-2 overflow-x-auto overflow-y-visible scrollBar-hidden border-b border-[#E7CBD2] w-full'>
                                        <button data-testid="patient-tab" onClick={() => handleTabChange('patient')} className={`px-2 pt-2.5 min-w-fit text-base font-semibold ${patientTabName === 'patient' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'patient' ? 'patient_tab' : ''}`}>
                                            Patient
                                        </button>
                                        {userType!=="user" && 
                                            <button id={'organization-user'} data-testid={'organization-user'} onClick={() => handleTabChange('organization-user')} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'organization-user' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'organization-user' ? 'patient_tab' : ''}`}>
                                                Organization User
                                            </button>
                                        }
                                    </div>
                                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                    </span> 
                                </div>

                                {patientTabName === "patient" && (
                                    <div>
                                        <div className='mt-[30px] flex justify-between items-center'>
                                            <p className='text-[24px] leading-[32px] font-normal text-[000000]'>Please attach the file that you wish to import</p>
                                            <button type='button' id="download_sample" data-testid="dowload-history" disabled={downloadfileLoading} onClick={handleDownloadFile} className={`px-[18px] py-2.5 xl:text-lg  text-[16px] font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[250px] text-center ml-4 bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                                {downloadfileLoading?<span className='pl-2.5'>{<Loader/>}</span>:<span className='pl-2.5'>Download Sample File</span>}
                                            </button>
                                        </div>
                                        <div className='mt-[30px]'>
                                            {!patientErrorMessage ? (
                                                <div className='h-[221px] border bg-[#F9FCFC] flex justify-between items-center border-dotted border-[#CB6A97] rounded-[6px]'>
                                                    {
                                                        !fileImportLoading ? (
                                                            <>
                                                                <div  className='flex cursor-pointer justify-center items-center w-[50%]'>
                                                                    <div {...getPatientRootProps()} className='flex justify-center flex-col items-center w-full h-full'>
                                                                        <input {...getPatientInputProps()} />
                                                                        <img src="/images/uploadicon-import.svg" alt="uploadicon" />
                                                                        <p className='pt-5 text-center text-[14px] leading-[19px] font-semibold text-[#416072]'>
                                                                            Drag and drop your file here
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <p className='text-[12px] leading-[16px] font-normal relative'>or <span className='oraboveline'></span></p>
                                                                <div className='flex justify-center items-center w-[50%]'>
                                                                    <div className='w-[162px] xl:w-[250px] h-fit rounded-md border-[#A1A1A9] mt-2 flex justify-center items-center relative'>
                                                                        <label htmlFor="fileUpload" disabled={fileImportLoading} className='px-4 py-2.5 text-lg  border border-[#972E4C] cursor-pointer text-center font-semibold bg-[#fff] rounded-[16px] w-[162px] xl:w-[250px] disabled:bg-[#777C88] text-[#972E4C]'>
                                                                            Browse File
                                                                        </label>
                                                                        <input
                                                                            id="fileUpload"
                                                                            disabled={fileImportLoading}
                                                                            type="file"
                                                                            // accept=".csv"
                                                                            onChange={(e) => {
                                                                                onDropPatient(e.target.files);
                                                                            }}
                                                                            className='opacity-0 absolute top-0 disabled:bg-[#777C88] left-0 text-[0px] w-[162px] xl:w-[250px] h-[55px] cursor-pointer z-10'
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </> 
                                                        ) : (<div className=' h-[250px] w-full relative   px-4  rounded-lg mt-3 '>
                                                            <div className='flex justify-center items-center mt-[90px]'>
                                                       
                                                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  spin-animation"></div>
                                                       
                                                            </div>
                                                        </div>)
                                                    } 
                                                   
                                                </div>
                                            ) : (
                                                <>
                                                    <div className='h-[221px] border bg-[#F9FCFC] flex justify-center items-center border-dotted border-[#CB6A97] rounded-[6px]'>
                                                        <div className='flex justify-center flex-col items-center'>
                                                            <img src="/images/file-error.svg" alt="file" />
                                                            <div className='rounded-[6px] bg-[#F8EEF1] relative text-[13px] text-[#416072] leading-[16px] w-[215px] mt-3 py-[8px] pl-[10px] pr-[40px]'>
                                                                <span title={patientErrorFileName}>{truncateFilename(patientErrorFileName, 25)}</span>
                                                                <img className='absolute top-[4px] cursor-pointer right-[10px]' onClick={handleGoBack} src="/images/closeiconimport.svg" alt="closeicon" />
                                                            </div>
                                                            <p className='text-[#C81720] text-[15px] leading-[16px] mt-3 text-center'>{patientErrorMessage}</p>
                                                        </div>
                                                    </div>
                                                    <div className='flex justify-center items-center mt-[20px]'>
                                                        <button type='button' id="goback" onClick={handleGoBack} className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[200px] ml-4 bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                                            Go Back
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        {!patientErrorMessage && 
                                            <ImportHistoryTable 
                                                data={data}
                                                patientTabName={patientTabName}
                                                isLoading={isLoading}
                                                isFetching={isFetching}
                                                error={error}
                                                status={status}
                                                loading={loading}

                                            />
                                        }

                                    </div>
                                )}
                                {userType!=="user" && <>
                                    {patientTabName === "organization-user" && (
                                        <div>
                                            <div className='mt-[30px] flex justify-between items-center'>
                                                <p className='text-[24px] leading-[32px] font-normal text-[000000]'>Please attach the file that you wish to import</p>
                                                <button type='button' id="download_sample"  data-testid="dowload-history" disabled={downloadfileLoading} onClick={handleDownloadFile} className={`px-[18px] py-2.5 xl:text-lg  text-[16px] font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[250px] text-center ml-4 bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                                    {downloadfileLoading?<span className='pl-2.5'>{<Loader/>}</span>:<span className='pl-2.5'>Download Sample File</span>}
                                                </button>
                                            </div>
                                            <div className='mt-[30px]'>
                                                {!organizationErrorMessage ? (
                                                    <div className='h-[221px] border bg-[#F9FCFC] flex justify-between items-center border-dotted border-[#CB6A97] rounded-[6px]'>
                                                        {!fileImportLoading ? (
                                                            <>
                                                                <div className='flex justify-center items-center w-[50%]'>
                                                                    <div {...getOrganizationRootProps()} className='flex justify-center flex-col items-center w-full h-full'>
                                                                        <input {...getOrganizationInputProps()} />
                                                                        <img src="/images/uploadicon-import.svg" alt="uploadicon" />
                                                                        <p className='pt-5 text-center text-[14px] leading-[19px] font-semibold text-[#416072]'>
                                                                            Drag and drop your file here
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <p className='text-[12px] leading-[16px] font-normal relative'>or <span className='oraboveline'></span></p>
                                                                <div className='flex justify-center items-center w-[50%]'>
                                                                    <div className='w-[162px] xl:w-[250px] h-fit rounded-md border-[#A1A1A9] mt-2 flex justify-center items-center relative'>
                                                                        <button type='button' className='px-4 py-2.5 text-lg  border border-[#972E4C] cursor-pointer font-semibold bg-[#fff] rounded-[16px] w-[162px] xl:w-[250px] text-[#972E4C]'>
                                                                            Browse File
                                                                        </button>
                                                                        <input type="file" 
                                                                            accept=".csv" 
                                                                            onChange={(e) => onDropOrganization(e.target.files)} 
                                                                            id='browse'
                                                                            className='opacity-0 absolute top-0 left-0 text-[0px] w-[162px] xl:w-[250px] h-[55px] cursor-pointer z-10' 
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) :
                                                            (
                                                                <div className=' h-[250px] w-full relative   px-4  rounded-lg mt-3 '>
                                                                    <div className='flex justify-center items-center mt-[90px]'>
                                                        
                                                                        <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  spin-animation"></div>
                                                        
                                                                    </div>
                                                                </div>
                                                            )
                                                        }

                                                    </div>
                                                ):
                                                    (
                                                        <>
                                                            <div className='h-[221px] border bg-[#F9FCFC] flex justify-center items-center border-dotted border-[#CB6A97] rounded-[6px]'>
                                                                <div className='flex justify-center flex-col items-center'>
                                                                    <img src="/images/file-error.svg" alt="file" />
                                                                    <div className='rounded-[6px] bg-[#F8EEF1] relative text-[13px] text-[#416072] leading-[16px] w-[215px] mt-3 py-[8px] pl-[10px] pr-[40px]'>
                                                                        <span title={organizationErrorFileName}>{truncateFilename(organizationErrorFileName, 25)}</span>
                                                                        <img className='absolute top-[4px] cursor-pointer right-[10px]' onClick={handleGoBack} src="/images/closeiconimport.svg" alt="closeicon" />
                                                                    </div>
                                                                    <p className='text-[#C81720] text-[15px] leading-[16px] mt-3 text-center'>{organizationErrorMessage}</p>
                                                                </div>
                                                            </div>
                                                            <div className='flex justify-center items-center mt-[20px]'>
                                                                <button type='button' id="goback" onClick={handleGoBack} className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[200px] ml-4 bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                                                    Go Back
                                                                </button>
                                                            </div>
                                                        </>
                                                    )}
                                            </div>
                                            {!organizationErrorMessage && 
                                                <ImportHistoryTable 
                                                    data={data}
                                                    patientTabName={patientTabName}
                                                    isLoading={isLoading}
                                                    isFetching={isFetching}
                                                    error={error}
                                                    status={status}
                                                    loading={loading}
                                                />   
                                            }                           
                                        </div>
                                    )}
                                </>}
                            </div>
                        </div>
                        {(helpGuideModel && helpguidestatus==="fulfilled") &&
                        <HelpGuideModal
                            setHelpGuideModel={setHelpGuideModel}
                            pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                        />
                        }
                        
                    </motion.div>
                   
                </div>
            </>
         


        </div>
    )
}
